module.exports = __webpack_public_path__ + "img/TechBuddy.84b319b8.png";